<div class="tw-flex tw-flex-col tw-rounded-lg tw-bg-dt-surface-card tw-h-full tw-relative">
  <div class="tw-p-7 tw-text-xl tw-font-medium md:tw-text-base">
    <span class="tw-w-full tw-justify-center tw-flex tw-items-center">
      {{ "pendingDeviceApprovalTitle" | i18n }}
    </span>
    <div
      (click)="dismiss()"
      data-testid="pendingDeviceApprovalDismiss"
      class="tw-absolute tw-top-6 tw-right-6 xs:tw-top-2 xs:tw-right-2 tw-p-2 tw-bg-dt-surface-elevated tw-rounded-full tw-cursor-pointer"
    >
      <icon [size]="6" [name]="'close'" [currentColor]="'neutral-600'"> </icon>
    </div>
  </div>

  <div class="tw-px-8 tw-mb-6 xs:tw-px-4">
    <p class="tw-mb-4 tw-text-[14px]">{{ "pendingDeviceApprovalBody" | i18n }}</p>

    <dl class="tw-grid tw-grid-cols-[auto_1fr] tw-gap-x-4 tw-gap-y-1 tw-text-[12px] tw-mb-4">
      <dt class="tw-text-color-text-secondary">{{ "device" | i18n }}</dt>
      <dd data-testid="pendingDeviceApprovalDeviceName">
        {{ data.request.deviceName || ("unknown" | i18n) }}
      </dd>
      <dt class="tw-text-color-text-secondary">{{ "ipAddress" | i18n }}</dt>
      <dd>{{ data.request.requestIp || ("unknown" | i18n) }}</dd>
      <dt class="tw-text-color-text-secondary">{{ "requested" | i18n }}</dt>
      <dd>{{ data.request.createdAt | date: "medium" }}</dd>
    </dl>

    <label class="tw-font-semibold tw-text-[14px] tw-text-color-text-tertiary">{{
      "fingerprintPhraseHeader" | i18n
    }}</label>
    <p
      data-testid="pendingDeviceApprovalFingerprintPhrase"
      class="tw-bg-color-surface-input tw-font-mono tw-text-[12px] tw-w-full tw-rounded-lg tw-px-3 tw-py-2 tw-break-words"
    >
      {{ data.fingerprintPhrase }}
    </p>

    <div class="tw-flex tw-items-start tw-gap-2 tw-mt-4">
      <input
        type="checkbox"
        id="pendingDeviceApprovalConfirmFingerprint"
        data-testid="pendingDeviceApprovalConfirmFingerprint"
        [(ngModel)]="confirmedFingerprint"
      />
      <label for="pendingDeviceApprovalConfirmFingerprint" class="tw-text-[12px]">
        {{ "deviceApprovalConfirmFingerprint" | i18n }}
      </label>
    </div>
  </div>

  <div
    class="tw-px-8 tw-py-6 xs:tw-p-4 xs:tw-flex-col xs:tw-gap-1 tw-flex tw-w-full tw-justify-between tw-gap-6 tw-rounded-b-xl tw-bg-dt-surface-elevated"
  >
    <app-gloss-button
      class="tw-w-full"
      [options]="{
        text: 'deny' | i18n,
        type: 'none',
        fullClass: 'tw-h-12 tw-w-full tw-px-6 tw-rounded-full tw-text-dt-text-headings',
        onClick: deny.bind(this),
        isEnabled: !submitting,
        testId: 'pendingDeviceApprovalDenyButton',
      }"
    >
    </app-gloss-button>
    <app-gloss-button
      class="tw-w-full"
      [options]="{
        text: 'approve' | i18n,
        type: 'none',
        fullClass: 'tw-bg-dt-custom-teal-11 tw-h-12 tw-w-full tw-px-6 tw-rounded-full',
        onClick: approve.bind(this),
        isEnabled: confirmedFingerprint && !submitting,
        testId: 'pendingDeviceApprovalApproveButton',
      }"
      [isLoading]="submitting"
    >
    </app-gloss-button>
  </div>
</div>
